import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useCopy } from './useCopy';
import { useConfigContext } from '../config';
var typeDefs = {
  text: String,
  showMessage: Boolean
};
var defaults = function defaults() {
  return {
    showMessage: true
  };
};
var events = {
  success: true,
  error: true,
  click: true
};
export var Copy = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Copy, _Component);
  function Copy() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.copy = useCopy();
    _this.config = useConfigContext();
    return _this;
  }
  return Copy;
}(Component);
Copy.template = template;
Copy.typeDefs = typeDefs;
Copy.defaults = defaults;
Copy.events = events;